import { CONTACT_EMAIL, APS_URL } from "../data/chapters";
import Button from "./Button";

/* The closing band. Same black as the loader and page curtain. */
export default function Footer({ heading = "Start a conversation.", text }) {
  return (
    <footer className="foot">
      <div className="foot-main">
        <p className="t-cap foot-kicker" data-rv="">Let's talk</p>
        <h2 className="t-display foot-title" data-rv="" style={{ "--d": "80ms" }}>{heading}</h2>
        <div className="foot-row" data-rv="" style={{ "--d": "160ms" }}>
          <p className="t-lg foot-text">{text || "Tell us who you're building for. A real person on our team will write back."}</p>
          <Button variant="primary" href={`mailto:${CONTACT_EMAIL}`} className="btn--invert">Start A Conversation</Button>
        </div>
      </div>
      <div className="foot-base t-cap">
        <span>© {new Date().getFullYear()} Digital Billions Group</span>
        <span className="foot-links">
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
          <a href="/login">Member login</a>
          <a href={APS_URL} target="_blank" rel="noopener noreferrer">APS ↗</a>
        </span>
      </div>
    </footer>
  );
}
